<template>
  <div id="app">
    <v-app>
      <v-card class="ma-10 pa-10">
        <v-card-title>投稿者用サインアップ</v-card-title>
        <v-card-subtitle
          >リリースおめでとうございます🎉<br />
          このサイトにプロダクトを投稿して、友達に自慢しましょう！<br />
          ※GeekSalonの受講生・卒業生のみプロダクトの投稿が可能です。<br />
          <br />
          アカウントをお持ちの方は<a @click="toSignIn">こちら</a>。
        </v-card-subtitle>
        <v-card-text>
          <v-text-field v-model="email" label="メールアドレス"> </v-text-field>
          <v-text-field type="password" v-model="password" label="パスワード">
          </v-text-field>
          <v-text-field
            type="password"
            v-model="passwordConfirmation"
            label="確認のためにパスワードをもう一回入力"
          >
          </v-text-field>
          <v-divider></v-divider>
          <br /><br />
          <v-card-subtitle
            >以下の質問はGeekSalonの卒業生であることを確認するためであり、回答は公開されません</v-card-subtitle
          >
          <v-text-field
            v-model="fullName"
            label="名前（例：田中実） WebExpertコースの場合はチーム名（例：Piraty）"
          >
          </v-text-field>
          <v-select
            v-model="region"
            :items="AREAS"
            label="地域（例：東京）"
          ></v-select>
          <v-select
            v-model="course"
            :items="COURSES"
            label="直近卒業したコース（例：WebExpert）"
          ></v-select>
          <v-text-field
            v-model="period"
            label="期（例：42）"
            type="number"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text v-on:click="signUp" class="sign-up-button"
            >サインアップ</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import { firebaseService } from "@/services/firebase"
import { COURSES_ARRAY, AREAS_ARRAY } from "@/lib/const"
export default {
  data() {
    return {
      email: "",
      password: "",
      passwordConfirmation: "",
      fullName: "",
      region: "",
      course: "",
      period: "",
      success: false,
      err: "",
    }
  },
  methods: {
    toSignIn() {
      this.$router.push("signin")
    },
    async signUp() {
      if (this.email === "" || this.email === null) {
        return alert("メールアドレスを入力してください")
      }
      if (this.password === "" || this.password === null) {
        return alert("パスワードを入力してください")
      }
      if (this.password !== this.passwordConfirmation) {
        alert("パスワードが一致しません")
        return
      }

      await firebaseService
        .signUp(this.email, this.password, {
          fullName: this.fullName.replace(/\s+/g, ""),
          region: this.region,
          course: this.course,
          period: this.period,
        })
        .catch((err) => {
          this.err = err.message
        })
      this.sendEmail()
    },
    async sendEmail() {
      await firebaseService.sendEmailVerification().catch((err) => {
        this.err = err.message
      })
      alert("メール送りました🔥🚀")
      location.reload()
    },
  },
  computed: {
    COURSES() {
      return COURSES_ARRAY
    },
    AREAS() {
      return AREAS_ARRAY
    },
  },
}
</script>

<style scoped>
.sign-up-button {
  width: 100%;
}
</style>
